// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompressedNftCreator } from './CompressedNftCreator';
import {
    CompressedNftCreatorFromJSON,
    CompressedNftCreatorFromJSONTyped,
    CompressedNftCreatorToJSON,
} from './CompressedNftCreator';
import type { CompressedNftMetadataCollection } from './CompressedNftMetadataCollection';
import {
    CompressedNftMetadataCollectionFromJSON,
    CompressedNftMetadataCollectionFromJSONTyped,
    CompressedNftMetadataCollectionToJSON,
} from './CompressedNftMetadataCollection';
import type { TokenStandard } from './TokenStandard';
import {
    TokenStandardFromJSON,
    TokenStandardFromJSONTyped,
    TokenStandardToJSON,
} from './TokenStandard';

/**
 * 
 * @export
 * @interface CompressedNftEventMetadata
 */
export interface CompressedNftEventMetadata {
    /**
     * 
     * @type {CompressedNftMetadataCollection}
     * @memberof CompressedNftEventMetadata
     */
    collection: CompressedNftMetadataCollection;
    /**
     * 
     * @type {Array<CompressedNftCreator>}
     * @memberof CompressedNftEventMetadata
     */
    creators: Array<CompressedNftCreator>;
    /**
     * 
     * @type {boolean}
     * @memberof CompressedNftEventMetadata
     */
    isMutable: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEventMetadata
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompressedNftEventMetadata
     */
    primarySaleHappened: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompressedNftEventMetadata
     */
    sellerFeeBasisPoints: number;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEventMetadata
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEventMetadata
     */
    tokenProgramVersion: string;
    /**
     * 
     * @type {TokenStandard}
     * @memberof CompressedNftEventMetadata
     */
    tokenStandard: TokenStandard;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEventMetadata
     */
    uri: string;
}

/**
 * Check if a given object implements the CompressedNftEventMetadata interface.
 */
export function instanceOfCompressedNftEventMetadata(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "collection" in value;
    isInstance = isInstance && "creators" in value;
    isInstance = isInstance && "isMutable" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "primarySaleHappened" in value;
    isInstance = isInstance && "sellerFeeBasisPoints" in value;
    isInstance = isInstance && "symbol" in value;
    isInstance = isInstance && "tokenProgramVersion" in value;
    isInstance = isInstance && "tokenStandard" in value;
    isInstance = isInstance && "uri" in value;

    return isInstance;
}

export function CompressedNftEventMetadataFromJSON(json: any): CompressedNftEventMetadata {
    return CompressedNftEventMetadataFromJSONTyped(json, false);
}

export function CompressedNftEventMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompressedNftEventMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'collection': CompressedNftMetadataCollectionFromJSON(json['collection']),
        'creators': ((json['creators'] as Array<any>).map(CompressedNftCreatorFromJSON)),
        'isMutable': json['isMutable'],
        'name': json['name'],
        'primarySaleHappened': json['primarySaleHappened'],
        'sellerFeeBasisPoints': json['sellerFeeBasisPoints'],
        'symbol': json['symbol'],
        'tokenProgramVersion': json['tokenProgramVersion'],
        'tokenStandard': TokenStandardFromJSON(json['tokenStandard']),
        'uri': json['uri'],
    };
}

export function CompressedNftEventMetadataToJSON(value?: CompressedNftEventMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'collection': CompressedNftMetadataCollectionToJSON(value.collection),
        'creators': ((value.creators as Array<any>).map(CompressedNftCreatorToJSON)),
        'isMutable': value.isMutable,
        'name': value.name,
        'primarySaleHappened': value.primarySaleHappened,
        'sellerFeeBasisPoints': value.sellerFeeBasisPoints,
        'symbol': value.symbol,
        'tokenProgramVersion': value.tokenProgramVersion,
        'tokenStandard': TokenStandardToJSON(value.tokenStandard),
        'uri': value.uri,
    };
}

